import axios from '.';

export default {
  create,
  createEvent
}

async function create(payload) {
  const response = await axios.post('/api/ad-impressions', payload);
  return response.data;
}

async function createEvent(payload) {
  const response = await axios.post('/api/ad-events/create-for-impression', payload);
  return response.data;
}
